import { toast } from '@codes/ui-kit/components/ui/use-toast';

import { useCustomMutation } from '@codes/shared';

import { uploadFile } from '../apis';

export const useUploadFiles = () =>
    useCustomMutation(
        async (body: FileList) => {
            const files = Array.from(body as FileList);
            console.log(files, 'files');
            const requests = files.map(file => {
                const formData = new FormData();
                formData.append('file', file);
                return uploadFile(formData);
            });

            const responses = await Promise.all(requests);

            return responses;
        },
        {
            onError: error => {
                toast({ title: `${error?.toString()}` });
            },
        }
    );
